import { render, staticRenderFns } from "./LoadingPanel.vue?vue&type=template&id=040234d0"
import script from "./LoadingPanel.vue?vue&type=script&lang=js"
export * from "./LoadingPanel.vue?vue&type=script&lang=js"
import style0 from "./LoadingPanel.vue?vue&type=style&index=0&id=040234d0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports